import { createStore } from 'vuex';
import ModuleRegistry from './ModuleRegistry';

export const registry = new ModuleRegistry(createStore({
    strict: process.env.NODE_ENV !== 'production'
}));

export default registry.getStore();
